
import { Component, Vue } from 'vue-property-decorator'
import ProblemPassageCurriculumUnit from '@/components/templates/ProblemPassageCurriculumUnit.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * ダミーデータ用の型
 * TODO api実装後に削除
 */
type dummyData = {
  /** 単元ID */
  id: number
  /** 単元名 */
  name: string
  /** 学習進捗 */
  learningProgress: LearningProgress.LearningProgressMaster
  /** 表示用番号 */
  viewNumber: string
  /** 学年コード */
  gradeCode: string
  /** 教科コード  */
  subjectCode: string
  /** 履歴一覧 */
  histories: {
    /** 問題ID */
    id: number
    /** レベル */
    level: number
    /** 学習進捗コード */
    learningProgressCode: string
  }[]
  /** 次の問題 */
  next: {
    /** 学習進捗コード */
    learningProgressCode: string
  }
}

/**
 * 講習会トレーニング単元別大問選択画面
 */
@Component({
  components: {
    ProblemPassageCurriculumUnit,
  },
})
export default class SelectSeminarProblemCurriculumUnit extends Vue {
  /** 単元情報 */
  private curriculumUnitProblems!: LearningProblemCurriculumUnit.ProblemPassage

  /** 画面レンダリングのフラグ */
  private pageView = false

  /**
   * 次の演習問題クリック時のイベント
   * TODO api実装後修正
   */
  private eventClickNextProblem(): void {
    alert(`次の問題を演習`)
  }

  /**
   * 履歴問題クリック時の処理
   * TODO api実装後修正
   *
   * @param problemId 問題ID
   */
  private eventClickHistoryProblem(problemId: number): void {
    alert(`ID:${problemId}の問題をクリック`)
  }

  /**
   * 履歴ボタン押下時の処理
   * TODO api実装後修正
   *
   * @param problemId 問題ID
   */
  private eventClickHistroyButton(problemId: number): void {
    alert(`ID:${problemId}の履歴ボタンをクリック`)
  }

  /**
   * 戻るボタン押下時の処理
   */
  private eventClickBackButton(): void {
    const returnPage = this.$prevPage.restorePage()
    if (!returnPage) {
      this.$router.push('/student/top')
      return
    }
    this.$router.push({
      path: returnPage.path,
      query: returnPage.query,
    })
  }

  /**
   * 単元情報取得
   * TODO api実装後修正
   */
  private getCurriculumUnit(): void {
    // フロントロジック実装時にコメントアウトを外す
    // const param = this.$route.params.curriculumUnitId
    let problemHistories: LearningProblemCurriculumUnit.History[] = []
    // 履歴問題のlevelをlearningProgressに変換
    if (this.dummyCurriculumUnit.histories.length > 0) {
      problemHistories = this.dummyCurriculumUnit.histories.map((history) => {
        let progress = LearningProgress.findByCode(history.learningProgressCode)
        return {
          id: 1,
          problemId: history.id,
          problemCode: 'dummy',
          level: history.level,
          learningProgress: progress,
        }
      })
    }
    // 次の演習問題のlevelをlearningProgressに変換
    let problemNext = { learningProgress: LearningProgress.LEVEL_A }
    if (this.dummyCurriculumUnit.next !== null) {
      let progress = LearningProgress.findByCode(this.dummyCurriculumUnit.next.learningProgressCode)
      problemNext = { learningProgress: progress }
    }
    this.curriculumUnitProblems = {
      id: this.dummyCurriculumUnit.id,
      name: this.dummyCurriculumUnit.name,
      learningProgress: this.dummyCurriculumUnit.learningProgress,
      gradeCode: this.dummyCurriculumUnit.gradeCode,
      subjectCode: this.dummyCurriculumUnit.subjectCode,
      problemHistories: problemHistories,
      problemNext: problemNext,
    }
  }

  /**
   * 初期処理
   */
  private mounted(): void {
    this.$loading.start()
    this.getCurriculumUnit()
    this.pageView = true
    this.$loading.complete()
  }

  /** ダミー単元 */
  private dummyCurriculumUnit: dummyData = {
    id: 1,
    name: 'ダミー単元aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    learningProgress: LearningProgress.LEVEL_B,
    viewNumber: '①',
    gradeCode: 'e1',
    subjectCode: 'm',
    histories: [
      { id: 9, level: 1, learningProgressCode: 'b' },
      { id: 8, level: 2, learningProgressCode: 'b' },
      { id: 7, level: 1, learningProgressCode: 'b' },
      { id: 6, level: 1, learningProgressCode: 'c' },
      { id: 5, level: 2, learningProgressCode: 'b' },
      { id: 4, level: 1, learningProgressCode: 'a' },
      { id: 3, level: 3, learningProgressCode: 'example' },
      { id: 2, level: 1, learningProgressCode: 'a' },
      { id: 1, level: 2, learningProgressCode: 'b' },
    ],
    next: { learningProgressCode: 'c' },
  }
}
